import type { ComboboxData, ComboboxItem } from "@mantine/core";
import { normalizeSelectData } from "../mantineComboboxData";

interface LogbookItem {
  lbname?: string;
  lbid?: string;
}
interface RawLogbookItem extends LogbookItem {
  colid?: string;
  colname?: string;
  list?: LogbookItem[];
}

/**
 * Maps raw logbook data into Mantine 7 grouped combobox data for Select.
 */
export const mapLogbookSelect = (logbooks: RawLogbookItem[]): ComboboxData => {
  const groupMap = new Map<string, ComboboxItem[]>();

  const ensureGroup = (name: string) => {
    if (!groupMap.has(name)) {
      groupMap.set(name, []);
    }
    return groupMap.get(name)!;
  };

  logbooks.forEach(logbook => {
    if (logbook.lbname && logbook.lbid) {
      ensureGroup("All Logbooks").push({
        label: logbook.lbname,
        value: logbook.lbid,
      });
    } else if (logbook.colname && logbook.list) {
      const items = ensureGroup(logbook.colname);
      logbook.list.forEach(item => {
        if (item.lbname && item.lbid) {
          items.push({ label: item.lbname, value: item.lbid });
        }
      });
    }
  });

  const result: ComboboxData = [
    {
      group: "All Logbooks",
      items: [{ label: "All Logbooks", value: "*" }],
    },
  ];

  groupMap.forEach((items, groupName) => {
    if (items.length > 0) {
      result.push({ group: groupName, items });
    }
  });

  return normalizeSelectData(result);
};
